import { useSubjectContext } from '@healthblocks-io/core'
import { useEffect, useMemo } from 'react'

export type IdentifierSystems = 'ssin' | 'synops' | 'oazis'
export type SubjectIdentifiers = Record<IdentifierSystems, string>

function useLeanSubject() {
  // Healthblocks Hooks
  const subjectContext = useSubjectContext()

  // Effects
  // ------------------------------------------------------------------------- /
  useEffect(() => {
    subjectContext?.subject?.mutate()
  }, [])

  // Memoized variables
  // ------------------------------------------------------------------------- /
  const { isLoading, subject } = useMemo(
    () => ({
      isLoading: subjectContext?.subject?.isLoading,
      subject: subjectContext?.subject?.data,
    }),
    [JSON.stringify(subjectContext?.subject?.data), subjectContext?.subject?.isLoading],
  )

  const isAuthenticated = useMemo(
    () => subjectContext.subject?.data?.id && !isLoading,
    [JSON.stringify(subjectContext.subject?.data), subjectContext?.subject?.isLoading],
  )

  const identifiers: SubjectIdentifiers = useMemo(() => {
    return (
      subjectContext.subject?.data?.identifiers?.reduce((accumulator, currentValue) => {
        accumulator[currentValue.system.toLowerCase() as IdentifierSystems] = currentValue.value

        return accumulator
      }, {} as SubjectIdentifiers) ?? ({} as SubjectIdentifiers)
    )
  }, [JSON.stringify(subjectContext?.subject?.data?.identifiers)])

  return {
    isLoading,
    isAuthenticated,
    subject,
    identifiers,
    refresh: subjectContext?.subject?.mutate,
  }
}

export { useLeanSubject }
